// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"bf02992b","239":"7080c0d4","455":"a30de25e","977":"0d1ec94c"}[chunkId] + ".chunk.js";
};